import React from "react"
import { Buttons } from "../../components/buttons"
import { EDIT_TYPE } from "../../../../../../../../types"
import { getHeadlineText } from "../../../../../../../../../../components/templates/chat/components/types/headline"
import { ChatStyle } from "../../../../../../../../../../components/templates/chat/components/styles/chat-style"
import { ChangeEvent } from "react"
import { StyledSelect } from "../../../../../../../../../../components/parts/styled-select"
import styled from "styled-components"
import {
  HEADLINE_BORDER_COLOR,
  HEADLINE_BORDER_COLOR_DEFAULT_ID,
} from "../../../../../../libs/style-info"
import BaseEditor, { IBaseEditorProps } from "../../abstract/base-editor"
import { container } from "../container"

interface IState {
  styleId: number
  value: string
}

class Component extends BaseEditor<IBaseEditorProps, IState> {
  private inputElementRef = React.createRef<HTMLInputElement>()

  constructor(props: IBaseEditorProps) {
    super(props)
    this.state = {
      styleId:
        this.props.content.blockStyle[0] || HEADLINE_BORDER_COLOR_DEFAULT_ID,
      value: getHeadlineText(this.props.content),
    }
    this.save = this.save.bind(this)
    this.cancel = this.cancel.bind(this)
    this.getBlockStyle = this.getBlockStyle.bind(this)
    this.validatedText = this.validatedText.bind(this)
    this.changeBorderColor = this.changeBorderColor.bind(this)
    this.change = this.change.bind(this)
    this.editMode = this.editMode.bind(this)
  }

  public componentDidMount(): void {
    // this.setFocus()
  }

  public render() {
    const borderColorClassName =
      (this.state.styleId &&
        HEADLINE_BORDER_COLOR[this.state.styleId].className) ||
      ""

    if (this.props.content._editMetaData.type === EDIT_TYPE.MENU) {
      return (
        <Wrapper onClick={this.editMode}>
          <StyledInput
            className={borderColorClassName}
            value={this.state.value}
            onChange={this.change}
            ref={this.inputElementRef}
          />
        </Wrapper>
      )
    }

    return (
      <Wrapper>
        <AdjustStyledSelectWithText>
          ボーター色:{" "}
          <StyledSelect
            onChange={this.changeBorderColor}
            value={this.state.styleId}
            options={HEADLINE_BORDER_COLOR.map(style => ({
              key: style.id,
              value: style.id,
              name: style.name,
            }))}
          />
        </AdjustStyledSelectWithText>
        <StyledInput
          className={borderColorClassName}
          value={this.state.value}
          onChange={this.change}
          ref={this.inputElementRef}
          autoFocus={true}
        />
        <Buttons save={this.save} cancel={this.cancel} />
      </Wrapper>
    )
  }

  protected save() {
    if (this.shouldRemoveContent()) {
      return this.props.actions.saveWithRemoveContent(this.props.content.uuid)
    }

    if (this.shouldShallowRemove()) {
      return this.props.actions.saveWithShallowRemoveContent(
        this.props.content.uuid,
      )
    }

    this.props.actions.saveContent({
      ...this.props.content,
      blocks: [
        {
          ...this.props.content.blocks[0],
          text: this.validatedText(),
        },
      ],
      blockStyle: this.getBlockStyle(),
    })
  }

  protected cancel() {
    if (this.shouldRemoveContent()) {
      return this.props.actions.cancelWithRemoveContent(this.props.content.uuid)
    }
    this.props.actions.cancelContent(this.props.content.uuid)
  }

  protected shouldShallowRemove() {
    return this.state.value === "" && getHeadlineText(this.props.content) !== ""
  }

  protected shouldRemoveContent() {
    return this.state.value === "" && getHeadlineText(this.props.content) === ""
  }

  protected setFocus(): void {
    if (this.inputElementRef.current) {
      this.inputElementRef.current.focus()
    }
  }

  private getBlockStyle() {
    if (this.state.styleId !== HEADLINE_BORDER_COLOR_DEFAULT_ID) {
      return [this.state.styleId]
    }
    return []
  }

  private validatedText() {
    return this.state.value.trim()
  }

  private changeBorderColor({ target }: ChangeEvent<HTMLSelectElement>) {
    const styleId = parseInt(target.value, 10) as number
    this.setState({
      styleId,
    })
  }

  private change({ target }: ChangeEvent<HTMLInputElement>) {
    this.setState({
      value: target.value,
    })
  }

  private editMode() {
    this.props.actions.clickContentEditor(this.props.content.uuid)
    this.forceUpdate()
  }
}

export const HeadlineEditor = container(Component)

const StyledInput = ChatStyle.HEADLINE.withComponent("input")

const AdjustStyledSelectWithText = styled.div`
  position: absolute;
  top: -60px;
`

const Wrapper = styled.div`
  position: relative;
`
